import styled, { css } from 'styled-components';
import { ReactResponsiveCarousel as ReactResponsiveCarouselComponent } from 'src/components';

const ReactResponsiveCarousel = styled(ReactResponsiveCarouselComponent)(
  () => css`
    ul.slider {
      max-width: 100%;
    }

    .slide img {
      width: auto;
    }
  `,
);

export default ReactResponsiveCarousel;
